<template>
  <div class="container">
    <div class="back" @click="clickHandle">返回</div>
    <div class="title">免责声明</div>
    <div style="width:40px;"></div>
  </div>
</template>

<script>
export default {
  methods:{
    clickHandle() {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  height: 0.48rem;
  display: flex;
  line-height: 48px;
  background-color: #fff;
  font-size: 18px;
  color: #333;
  position: relative;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 8px;
  .back{
    height: 48px;
    padding-left: 16px;
    line-height: 48px;
    display: inline-block;
    color: #ff9a58;
    left: 16px;
    font-size: 12px;
  }
  .title{
    flex: 1;
    display: flex;
    justify-content: center;
  }
}
</style>